function init_dildogame(from_php){
    var main=$(".place.dildogame");

    var mobile=_isMobileObj.take();
    if(mobile){
        main.addClass("mobile");
    }
    if(_ON_DEV){
        console.log(from_php);
    }
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }

    var semaphoreSuit= new mySemaphore();

    var girl_id=intval(from_php.girl_id);
    var gameInitObj=new afterInit();
    var mobileBut=[
        {
            url: _IMG_SERV+"/gfx/place/dildogame/ui/mobile/1.png",
            pos:[220,680]
        },
        {
            url: _IMG_SERV+"/gfx/place/dildogame/ui/mobile/2.png",
            pos:[640,680]
        },
        {
            url:_IMG_SERV+"/gfx/place/dildogame/ui/mobile/3.png",
            pos:[1060,680]
        }
    ];
    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex()
    };

    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;
    var ajaxTimeHandler=_moduleTimeHandler.getNewIndex();

    function postAjax(to_send,conf){
        if(typeof conf=="undefined"){
            conf={};
        }
        conf=$.extend({wait:20,onEnd:function(){}},conf);
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"dildogame"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){


                    _moduleTimeHandler.setOne(ajaxTimeHandler,function(){
                        if(intval(data.was_ended)>intval(from_php.was_ended)){
                            _mySound.playSound("girl_moan");
                            if(typeof data.progressLevelHave!="undefined" && intval(data.progressLevelHave)>=8){
                                $.goToLocation("dildoanim");
                            }
                            else{
                                $.goToLocation("dildoanim/"+girl_id+"/");
                            }

                            return false;
                        }
                        else if(intval(data.was_ended)>0 && data.was_paid==0){
                            $.goToLocation("dildogame/"+girl_id+"/");
                            return false;
                        }
                        from_php=$.extend(from_php,data);
                        if(_ON_DEV){
                            console.log(from_php);
                        }
                        updateState();

                        semaphoreSuit.clear();
                        conf.onEnd();
                    },conf.wait);

                }

            },"json");
        }
    }

    function updateState(){

        if(from_php.was_paid){
            if(from_php.was_paid==1){
                showState("game_init");
                console.log("game_init");
            }
            else{
              console.log("game");
                showState("game");
            }


        }
        else{
          console.log(from_php);
            if(from_php.repeat_val && from_php.was_error){
                showState("val_lose");
                console.log("val_lose");

                /*
                 * repeat_val
                 * val_need
                 * was_error
                 *
                 *
                 */

                //can repeat, lose_val
            }
            else if(typeof from_php.res!="undefined"){
                if(from_php.game_conf.state.type=="coin"){
                    showState("coin_win");
                    /*
                     * res:
                     * coin_have
                     * coin_add
                     * coin_need
                     * try_count_have
                     * try_count_add
                     *
                     */
                }
                else{
                    showState("val_win");
                    /*
                     * res:
                     * val_have
                     * val_need
                     *
                     *
                     *
                     */
                }
            }
            else{
                if(from_php.try_count>0){
                    // if(from_php.part_ended==0 && from_php.coins==0){
                    //     showState("before_init");
                    //     console.log("before_init");
                    // }
                    // else{
                        showState("init");
                    // }


                }
                else{
                    showState("need_try");
                }
            }
        }
    }


    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({start_game:1});
        });



        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1});
            });
        });



        var i,bum,wrap=main.find("#mobileButWrap"),html="";
        for(i in mobileBut){
            bum=mobileBut[i];
            html+='<div class="but" style="left:'+bum.pos[0]+'px;'+
            'top:'+bum.pos[1]+'px;background-image:url('+bum.url+')"></div>';
        }
        wrap.append(html);

        updateState();
    }


    var stateIndex={
        "game":[_moduleTimeHandler.getNewIndex()]
    };
    var stateFun={
        "coin_win":function(win){
            var i,bum,is_premium="",html="";
            for(i=0;i<from_php.res.coin_add_max;i++){
                if(i<from_php.res.coin_add){
                    if(i>=from_php.res.coin_add/2 && from_php.game_conf.bonus1){
                        is_premium=" premium";
                    }
                    html+="<div class='star have"+is_premium+"'></div>";
                }
                else{
                    html+="<div class='star'></div>";
                }
            }
            win.find(".starWrap").html(html);
            if(is_premium){
                win.find(".starWrap").addClass("premium");
            }

            var str="0";
            if(from_php.res.try_count_add>0){
                str="+"+from_php.res.try_count_add;
            }
            win.find(".putRes[data-type='try_count_add']").html(str);
        },
        "val_win":function(win){
            win.find(".putRes[data-type='val_have']").html(numberFormat(from_php.res.val_have,0,0));
            win.find(".putRes[data-type='val_need']").html(numberFormat(from_php.res.val_need,0,0));


        },
        "val_lose":function(win){
            win.find(".reasonJS").html(from_php.langs["fail"+from_php.was_error]);
            win.find(".putRes[data-type='repeat_val']").html(numberFormat(from_php.repeat_val,0,0));
            var val_need=5000;
            from_php.repeat_val=intval(from_php.repeat_val);
            from_php.repeat_moves=intval(from_php.repeat_moves);
            if(from_php.repeat_val>0){
                val_need=Math.ceil(from_php.repeat_val/(from_php.repeat_moves/100));
            }
            win.find(".putRes[data-type='val_need']").html(numberFormat(val_need,0,0));
//            var txt=from_php.langs["fail"+from_php.was_error];
//            win.find(".failText").html(txt);


            var repeat_type="premium";
            if(from_php.try_count>=from_php.conf_user.currency_repeat){
                repeat_type="currency";
            }
//            if(from_php.repeat_moves<10 || 1==1){
//                repeat_type="";
//            }


            win.find(".priceCellJS").addClass("hide");

            if(repeat_type){
                win.find(".priceCellJS").filter("[data-price='"+repeat_type+"']").removeClass("hide");
                win.find(".butRepeatJS").off("click.repeat").on("click.repeat",function(){
                    var th=$(this),repeat_type=0,repeat_names={"currency":1,"premium":2};
                    var repeat_name=th.attr("data-price");
                    if(typeof repeat_names[repeat_name]!="undefined"){
                        repeat_type=repeat_names[repeat_name];
                    }
                    $.goToLocation("dildogame/"+girl_id+"/",{buy_repeat:1,repeat_type:repeat_type})
    //                postAjax({buy_repeat:1,repeat_type:repeat_type});
                });
            }
        },
        "before_init":function(win){

            win.find("#playGameJS").off("click").on("click",function(){
                showState("init");
            });

        },
        "init":function(win){
            var infoBox=win.find(".mainColl.info");
            infoBox.attr("data-isMobile",mobile);
            infoBox.find(".uiRow").off("click").on("click",function(){
               mobile=(mobile+1)%2;
               infoBox.attr("data-isMobile",mobile);
               _isMobileObj.set(mobile);
               win.find(".textfill").textfill();
               if(mobile){
                   main.addClass("mobile");
               }
               else{
                   main.removeClass("mobile");
               }
            });

        },
        "need_try":function(win){
            _timerManager.addTimer(".place.dildogame .timerKeyWaitJS",from_php.try_time,1);
        },
        "game":function(win){
            gameCover.addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");

            var animDildoObj=new dildoAnim({
                girl_a:intval(from_php.girl_id),
                girl_b:1003
            });
            var arrObj={};
            var addImagesMore=animDildoObj.preparePreloader();
            addImagesMore.cloud=_IMG_SERV+"/gfx/place/dildogame/cloud.png";
            addImagesMore.cloud2=_IMG_SERV+"/gfx/place/dildogame/cloud2.png";
            addImagesMore.hero=_IMG_SERV+"/gfx/place/dildogame/hero/skeleton.json";



            dildoHero=function(conf){
                myPixiElement.spine.call(this,conf);
                this.block_anim=0;
                this.force_anim="";
            };
            dildoHero.prototype = Object.create(myPixiElement.spine.prototype);
            dildoHero.prototype= $.extend(dildoHero.prototype,{
                myPlayAnim:function(name,force){
                    if(this.block_anim){
                        if(force){
                            this.force_anim=name;
                        }
                    }
                    else{
                        this.block_anim=1;
                        this.state.setAnimation(0, name, false);
                    }
                }
            });
            var buttonSlow=main.find("#buttonSlowGameJS");
            buttonSlow.css("opacity",1);

            var dildoHeroObj;


            var guitarGameObj=new guitarGame(main.find("#gameWrapJS"),{
                buttonContainerPos:[0,0],
                addImagesMore:addImagesMore,
                gameProgress:from_php.gameProgress,
                gameConf:from_php.game_conf.stages,
                mobile:mobile,
                bonus2:from_php.game_conf.bonus2,
                button_mobile_path:mobileBut,
                score_repeat:intval(from_php.game_conf.repeat.val),
                onLoad:function(){
                    var cloud=new myPixiElement.img({img:"cloud"});
                    cloud.y=68;
                    cloud.x=-60;
                    this.externalContainer.addChild(cloud);
                    this.externalContainer.x=950;
                    this.externalContainer.y=400;

                    dildoHeroObj=new dildoHero({
                        img:"hero",
                        spine_conf:{
                            freeze_part:0,
                            anim_name:"standby",
                            updateAnim:true,
                            anim_loop:false,
                            spineResource:this.resources,
                            onAnimComplete:function(){
                                this.block_anim=0;
                                if(this.force_anim){
                                    this.state.setAnimation(0, this.force_anim, false);
                                    this.force_anim="";
                                    this.block_anim=1;
                                }
                                else{
                                    this.state.setAnimation(0, this.conf.spine_conf.anim_name, false);
                                }
                            }
                        }
                    });
                    if(mobile){
                        dildoHeroObj.y=this.conf.marginTopMobile;
                    }

                    this.animContainer.addChild(dildoHeroObj);

//                    this.animContainer;

                    arrObj=animDildoObj.addAnimToContainer(
                        this.externalContainer,
                        this.resources
                    );
                    var cloud2=new myPixiElement.img({img:"cloud2"});
                    cloud2.y=68;
                    cloud2.x=-60;
                    this.externalContainer.addChild(cloud2);
                    this.externalContainer.x=950;
                    this.externalContainer.y=400;


                    main.find(".hideOnGameJS").addClass("hide");
                    main.find(".showOnGameJS").removeClass("hide");

                    _mySound.playSound("dildo_smash");
                    _moduleTimeHandler.add(function(){
                        _mySound.playSound("girl_moan_new");
                    },2500);


                    this.start();
                },
                onEnd:function(){
                    var res=guitarGameObj.prepareResAjax();
                    var wait=20;

                    var to_post={
                        game_conf:Base64.encode(secureStr),
                        val:res.score,
                        val_max:res.score_max,
                        is_boss:res.is_boss,
                        fail_id:res.fail_id
                    };
                    if(res.fail_id==2){
                        wait=3000;
                        _mySound.playSound("pvpfinish");
                        dildoHeroObj.myPlayAnim("bad",1);
                    }

                    _mySound.stopSound("dildo_smash");

                    postAjax(to_post,{wait:wait});

                },
                onItem:function(line_id){
                    var line2name=["throw_left","throw_center","throw_right"];
                    dildoHeroObj.myPlayAnim(line2name[line_id]);

                    //bad, good1,good2,throw_center,throw_left,throw_right
                },
                onUpdate:function(delta){
                    var i;
                    for(i in arrObj){
                        arrObj[i].myUpdate(delta);
                    }
                    dildoHeroObj.myUpdate(delta);
                },
                onBoss:function(){
                    dildoHeroObj.myPlayAnim("good"+mt_rand(1,2),1);
                    var cells=main.find("#gameInfoBoss .box");
                    var timeIndexAnim=_moduleTimeHandler.getNewIndex();
                    var timeIndexQueue=_moduleTimeHandler.getNewIndex();
                    var howlong_arr=[200,1000,200];
                    function useBox(i){
                        if(i>1){
                            return false;
                        }
                        cells.eq(i).css("opacity",0).removeClass("hide");
                        _moduleTimeHandler.queueAdd(timeIndexQueue,function(){
                            cells.eq(i).animate({'opacity':1},howlong_arr[0]);
                            _moduleTimeHandler.setOne(timeIndexAnim,function(){
                                _moduleTimeHandler.queueTrigger(timeIndexQueue);
                            },howlong_arr[0]+howlong_arr[1]);
                        });
                        _moduleTimeHandler.queueAdd(timeIndexQueue,function(){
                            cells.eq(i).animate({'opacity':0},howlong_arr[2])
                            _moduleTimeHandler.setOne(timeIndexAnim,function(){
                                _moduleTimeHandler.queueTrigger(timeIndexQueue);
                            },howlong_arr[2]);
                        });
                        _moduleTimeHandler.queueAdd(timeIndexQueue,function(){
                            cells.eq(i).addClass("hide");
                           useBox(i+1);
                        });
                        _moduleTimeHandler.queueTrigger(timeIndexQueue);
                    }
                    useBox(0);


                },
                onSlowTrigger:function(){
                    buttonSlow.animate({'opacity':0},600);
                }
            });
            buttonSlow.off("click").click(function(){
                guitarGameObj.makeGameSlower();
            });

        },
        game_init:function(win){
            main.find(".wrapGirlUI.hideOnGameJS").addClass("hide");
            var but=win.find(".formSubmit");
            var step=0;
            _moduleTimeHandler.add(function(){
                step=(step+1)%2;
                if(step==0){
                    but.addClass("blink");
                }
                else{
                    but.removeClass("blink");
                }
            },1000);
            main.find("#butStartAfterInitJS").click(function(){
                 postAjax({
                    show_game:1
                });

            });


        }
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.gameninja .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }




        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        var win=main.find(".stateJS[data-state='"+state+"']");
        stateFun[state](win);

        main.find(".textfill").textfill();
        state_cur=state;
    }



    init();

//    showState("game");

//    gameCanv.one("gameReady",function(){
        main.find(".preloadJS").addClass("hide");
        main.find(".preloadAfterJS").removeClass("hide");
        gameInitObj.load();
//    });

    from_php.game_conf.girl_id=from_php.girl_id;

     _moduleEvents.one("moduleClear",function(){
        _mySound.stopSoundAll();
    });


    $.handleBottomMenu();
    $.handleSelect();






}
